module.exports = __webpack_public_path__ + "static/media/img-mobile-offer.be6dde2f.png";